import { ApiClient } from "@dining/api-client";
import { config } from "../configs";
import { appInsightsEvents } from "./constants";
import { v4 as uuidv4 } from "uuid";
import { AppContextType } from "@microsoft/metaos-appcontextutils";
import { trackEvent } from "./appInsights";
import { IApplicationInsights } from "@microsoft/applicationinsights-web";

export class Client {
  public instance: ApiClient;
  getContext: () => Promise<AppContextType>;
  appInsights: IApplicationInsights;
  clientSource?: string;
  constructor(
    appInsights: IApplicationInsights,
    getContext: () => Promise<AppContextType>,
    clientSource?: string,
  ) {
    this.appInsights = appInsights;
    this.getContext = getContext;
    this.clientSource = clientSource;
    this.instance = new ApiClient(config.endpoint, this.http);
  }

  public http: {
    fetch(url: RequestInfo, init?: RequestInit | undefined): Promise<Response>;
  } = {
    fetch: async (url: RequestInfo, init?: RequestInit | undefined) => {
      const initParam = init || {};
      const context = await this.getContext();
      initParam.headers = {
        ...initParam.headers,
        Authorization: "Bearer " + context.authData?.accessToken,
        "X-Correlation-Id": context.authData?.correlationId || uuidv4(),
        ...(this.clientSource ? { clientSource: this.clientSource } : {}),
      };

      trackEvent(this.appInsights, appInsightsEvents.System.BackendCall, context, {
        requestUrl: url.toString(),
        requestContent: init?.body ? init.body : "",
        clientSource: this.clientSource,
      });

      return fetch(url, initParam);
    },
  };
}
